import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import { type Editor, Transforms } from 'slate';
import { type EmbedElement } from '../../../types/aha-editor';
import EmbedCommon from '../EmbedCommon';

// Insert an embed block into the editor.
class ToolInsertEmbed extends Tool {
  static toolName = 'Embedded content';
  // TODO: Consider having a separate tool for each link type we support.
  static iconClass = 'fa-regular fa-cloud';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('embedSchema'));
  }

  // Open a modal so the user can paste in a link.
  static action({ editor }: ToolArgs): void {
    // TODO: Better popup modal for pasting the URL.
    const url = prompt(
      'Enter a URL to embed content from YouTube, Figma, Wistia, or Vimeo:'
    );
    if (url) {
      ToolInsertEmbed.insertEmbed(editor, url);
    }
  }

  // Insert the embed URL into the editor.
  static insertEmbed(editor: Editor, url: string) {
    // Validate the URL.
    const embedType = EmbedCommon.embedTypeForUrl(url);
    if (!embedType) {
      return;
    }

    // Insert the node into the editor with the temporary data while we wait
    // for the upload to the server.
    const newNode: EmbedElement = {
      type: 'embed',
      embed_src: url,
      embed_display: 'frame',
      resizer_width: 500,
      resizer_height: 500 / (16 / 9),
      resizer_originalWidth: 2048,
      resizer_originalHeight: 2048 / (16 / 9),
      children: [{ text: '' }],
    };
    Transforms.insertNodes(editor, newNode);
  }
}

export default ToolInsertEmbed;
